import { Component, Inject, LOCALE_ID, NgZone, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { filter, map, mergeMap, take, takeUntil } from 'rxjs/operators';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { TournamentService } from 'src/app/services/tournaments/tournament.service';
import { CommonTournament, Tournament } from 'src/app/services/tournaments/tournaments.models';
import { LoggedStatus } from 'src/app/services/auth/login/login.models';
import { tournamentsTrx } from 'src/app/router-translation.labels';
import { TournamentInfoBoxComponent } from '../tournament-info-box/tournament-info-box.component';
import { Router } from '@angular/router';
import { TournamentDetailsService } from 'src/app/services/tournaments/tournament-details.service';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { isPlatformServer } from '@angular/common';
import { LicenceService } from 'src/app/services/utils/licence.service';

@Component({
  selector: 'app-tournament-category',
  templateUrl: './tournament-category.component.html',
  styleUrls: ['./tournament-category.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TournamentCategoryComponent extends TournamentInfoBoxComponent {

  tournments: CommonTournament[] = [];
  tournamentsAll: CommonTournament[] = [];
  currentRoute: any;
  public tournamentsTrx = tournamentsTrx;
  constructor(
    @Inject(LOCALE_ID) public locale: string,
    @Inject(PLATFORM_ID) private platformId,
    public router: Router,
    public tournamentDetailsService: TournamentDetailsService,
    public tournamentService: TournamentService,
    public detectDeviceService: DetectDeviceService,
    protected _ngZone: NgZone,
    public loginStatus: LoginStatusService,
    protected licenceService: LicenceService
  ) {
    super(locale, router, tournamentDetailsService, tournamentService, detectDeviceService, _ngZone, licenceService);
  }

  isServer: boolean;
  isLoading = false;
  status: any = 'all';
  numberTournaments = 0;

  ngOnInit(): void {
    this.isServer = isPlatformServer(this.platformId);
    this.isLoading = true;
    this.currentRoute = this.router.url;
    this.tournamentService.getInAppTournamentMetaData().pipe(take(1)).subscribe((resp) => {
      this.setSEOTags(resp.seo?.metaTitle, resp.seo?.metaDescription, resp.seo?.relCanonical)
    })
    this.getTournament();

  }

  getTournament() {
    this.loginStatus.getLoginStatus().pipe(
      filter(status => status.isLogged !== LoggedStatus.voidState),
      mergeMap((status) => {
        return this.tournamentService.updateTournamentsStore().pipe(
          map(tournaments => ({ tournaments, isLogged: status }))
        );
      }),
      takeUntil(this.unsubscribe)
    ).subscribe(resp => {
      this.isLoading = false;
      // this.numberTournaments = resp.length;
      console.log('all tour', resp);
      this.tournments = resp.tournaments;
      this.tournamentsAll = resp.tournaments;
      if (resp.isLogged.isLogged == 1) {
        this.tournamentService.getPrivateTournaments().pipe(takeUntil(this.unsubscribe)).subscribe(respPrivate => {
          this.numberTournaments = respPrivate.length;
          this.tournments = respPrivate;
          this.tournamentsAll = respPrivate;
        })
      }
    });
  }
  filterTour(status: any) {
    this.status = status;
    let allTour = this.tournamentsAll;
    if (status != 'all')
      this.tournments = allTour.filter(x => !x.isNetworkTournament && (x as Tournament).tournamentType == this.status)
    else
      this.tournments = allTour;

    console.log('filter', this.tournments)
  }

}
